import React from "react";
import CurrencyInput, { CurrencyInputOnChangeValues } from "react-currency-input-field";

interface CustomCurrencyInputProps {
  value: string | number;
  name: string;
  onValueChange: (
    value: string | undefined,
    name?: string,
    values?: CurrencyInputOnChangeValues
  ) => void;
  placeholder?: string;
  prefix?: string;
  decimalsLimit?: number;
  className?: string;
  disabled?:any;
  readOnly?:any;
  maxLength?: number; // Added maxLength as a prop

}

const CurrencyInputComponent: React.FC<CustomCurrencyInputProps> = ({
  value,
  name,
  onValueChange,
  placeholder = "Enter",
  prefix = "$",
  decimalsLimit = 2,
  className="w-full h-[32px] px-4 py-2 border placeholder:text-[13px] placeholder:text-gray-500  border-gray-400 mt-[2px] hover:border-gray-600 rounded-[5px] bg-gray-50 text-gray-800 font-normal focus:outline-none focus:ring-[1.5px]  focus:ring-greenBg  mb-1 focus:border-transparent transition-all duration-300  text-[13px]",
  disabled = false, 
  readOnly,
  maxLength = 5,  

}) => {
  return (
    <CurrencyInput
      value={value}
      name={name}
      onValueChange={(value, name, values) => onValueChange(value, name, values)}
      placeholder={placeholder}
      prefix={prefix}
      decimalsLimit={decimalsLimit}
      className={className}
      disabled={disabled}
      maxLength={maxLength} // Dynamic maxLength

    />
  );
};

export default CurrencyInputComponent;
